import { useTranslation } from 'react-i18next';
import './WixEntryLoader.css';

// The single full-screen loader for the Wix App Market entry + onboarding. Rendered
// by App.js while it resolves the Wix instance AND by WixOnboarding, so the user sees
// ONE continuous purple loader from app-open until the first onboarding screen is
// ready — instead of the white portal spinner flickering into the purple one.
// `text` overrides the caption (e.g. WixConnect uses "Connecting to Wix…"); it
// defaults to the onboarding loading line so existing callers are unchanged.
export default function WixEntryLoader({ text }) {
  const { t } = useTranslation();
  return (
    <div className="wel-screen">
      <div className="wel-grid" aria-hidden="true" />
      <div className="wel-glow" aria-hidden="true" />
      <div className="wel-stack">
        <div className="wel-ring" />
        <p className="wel-text">{text || t('wel_loading')}</p>
      </div>
    </div>
  );
}
